import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useCidco } from "./CidcoLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = useCidco();
  const list = data.governing_body || [];
  return (
    <div data-testid="cid-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="cyan" testidPrefix="cid-gb-page" />
      </PageBody>
    </div>
  );
}
